import React from 'react';
import { useAuth } from '../context/AuthContext';
import SuperAdminDashboard from './dashboards/SuperAdminDashboard';
import HrManagerDashboard from './dashboards/HrManagerDashboard';
import EmployeeDashboard from './dashboards/EmployeeDashboard';
import FinanceDashboard from './dashboards/FinanceDashboard';
import SalesManagerDashboard from './dashboards/SalesManagerDashboard';
import SalesRepDashboard from './dashboards/SalesRepDashboard';

const Dashboard = () => {
  const { user } = useAuth();

  if (!user) return null;

  // Role based routing for home page (SRS Role Table Compliant)
  if (user.role === 'super_admin') {
    return <SuperAdminDashboard />;
  }

  if (user.role === 'hr_manager') {
    return <HrManagerDashboard />;
  }
  
  if (user.role === 'employee') {
    return <EmployeeDashboard />;
  }

  if (user.role === 'finance_manager') {
    return <FinanceDashboard />;
  }

  if (user.role === 'sales_manager') {
    return <SalesManagerDashboard />;
  }

  if (user.role === 'sales_rep') {
    return <SalesRepDashboard />;
  }

  // Final Fallback
  return (
    <div className="p-10 bg-white rounded-card border shadow-soft text-center space-y-4">
      <div className="w-20 h-20 bg-primary/5 rounded-full flex items-center justify-center text-primary mx-auto font-black text-2xl uppercase">
        {user.full_name?.charAt(0)}
      </div>
      <div>
        <h1 className="text-xl font-black text-gray-900 uppercase tracking-tight">System Portal</h1>
        <p className="text-gray-500 text-sm mt-1 uppercase font-bold tracking-tighter">Welcome {user.full_name}</p>
        <p className="text-xs text-gray-400 mt-4 italic">No dashboard view configured for role: {user.role}</p>
      </div>
    </div>
  );
};

export default Dashboard;